import * as React from 'react';
import { SVGProps } from 'react';

const IconBookStrokedSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 1a1 1 0 0 1 1 1v8l-.005.102A1 1 0 0 1 9 11H3a1 1 0 0 1-.995-.898L2 10V2a1 1 0 0 1 1-1h6Zm-6 9h6V9H4.5a.5.5 0 0 1 0-1H9V2H6v4L5 5 4 6V2H3v8Z"
    />
  </svg>
);
export default IconBookStrokedSizeXs;
